import { ThemeProvider, Button, Dialog } from "@mui/material";
import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import { icons } from "../../components/Utilities/UtilitiesWD";
import AssignWebLead from "../../components/WebLeads/AssignWebLead";
import UpdateAddress from "../../components/WebLeads/UpdateAddress";
import { getUnassignedLeads } from "../Admin/Utilities/api";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import UpdateLead from "../../components/WebLeads/UpdateLead";
import { useIsDarkMode } from "../../theme/ThemeContext";
import { useAppMuiTheme } from "../../theme/MuiThemeBridge";

const WebLead = () => {
  const [leads, setLeads] = useState(null);
  const [assignInfo, setAssignInfo] = useState(null);
  const [updateInfo, setUpdateInfo] = useState(null);
  const [flag, setFlag] = useState(null);
  const isDark = useIsDarkMode();

  // MaterialTable renders MUI table cells / pagination / search whose text
  // color comes from the MUI palette, so the palette mode has to follow the
  // in-app toggle or dark rows end up with near-black text.
  const defaultMaterialTheme = useAppMuiTheme();

  useEffect(() => {
    getUnassignedLeads(setLeads);
  }, []);
  useEffect(() => {
    getUnassignedLeads(setLeads);
  }, [assignInfo, flag]);

  const handleAssign = (data) => {
    setAssignInfo(data);
  };
  const handleUpdate = (data) => {
    setUpdateInfo(data);
  };

  return (
    <div className="m-2">
      {updateInfo && (
        <UpdateLead
          assignInfo={updateInfo}
          setAssignInfo={setUpdateInfo}
          setFlag={setFlag}
        />
      )}
      {assignInfo && (
        <AssignWebLead assignInfo={assignInfo} setAssignInfo={setAssignInfo} />
      )}
      {leads && !assignInfo && !updateInfo && (
        <ThemeProvider theme={defaultMaterialTheme}>
          <MaterialTable
            style={{
              backgroundColor: isDark ? "#1e293b" : "#ffffff",
              color: isDark ? "#f1f5f9" : "#1e293b",
            }}
            options={{
              pageSize: 10, // make initial page size
              emptyRowsWhenPaging: false, // To avoid of having empty rows
              pageSizeOptions: [5, 10, 15, 25],
              headerStyle: {
                search: true,
                backgroundColor: isDark ? "#0f172a" : "#f1f5f9",
                color: isDark ? "#e2e8f0" : "#334155",
              },
              searchFieldStyle: {
                color: isDark ? "#f1f5f9" : "#0f172a",
                borderBottom: isDark
                  ? "1px solid #475569"
                  : "1px solid #cbd5e1",
              },
              rowStyle: (rowData) => {
                return {
                  fontSize: 14,
                };
              },
            }}
            columns={[
              {
                title: "Customer",
                field: "customerName",
              },
              {
                title: "Email",
                field: "customerEmail",
              },
              {
                title: "Phone",
                field: "customerPhone",
              },
              {
                title: "Address",
                field: "customerAddress",
                render: (rowData) => {
                  return <UpdateAddress data={rowData} setFlag={setFlag} />;
                },
              },
              {
                title: "Working On",
                field: "customerWorkingOn",
              },
              {
                title: "Looking For",
                field: "customerLookingFor",
                render: (rowData) => {
                  return (
                    <div className="flex max-h-32 overflow-auto">
                      <p>{rowData.customerLookingFor}</p>
                    </div>
                  );
                },
              },
              {
                title: "Assign",
                field: "_id",
                render: (rowData) => {
                  return (
                    <>
                      <div className="flex">
                        <div className=" border p-1 m-1 justify-center items-center border-slate-300 bg-slate-50 text-slate-800 hover:bg-slate-100 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-700 rounded-md font-black">
                          <button
                            onClick={() => handleAssign(rowData)}
                            variant="outlined"
                          >
                            Assign
                          </button>
                        </div>

                        <div className=" border p-1 m-1 justify-center items-center border-slate-300 bg-slate-50 hover:bg-slate-100 dark:border-slate-600 dark:bg-slate-900 dark:hover:bg-slate-700 rounded-md">
                          <button
                            onClick={() => handleUpdate(rowData)}
                            className=""
                          >
                            <p className="font-black text-slate-800 dark:text-slate-100">
                              Update
                            </p>
                          </button>
                        </div>

                        <a
                          className="flex m-1 p-1 border border-slate-300 bg-slate-50 text-slate-800 hover:bg-slate-100 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-700 justify-between justify-center rounded-md font-black"
                          href={`mailto:${rowData.customerEmail}?subject=${rowData.customerWorkingOn} - ${rowData.customerName}&bcc=webleadtracking@bigclumber.com`}
                        >
                          <div className="flex">
                            <div className="w-11/12 flex ">
                              <p className="font-black text-slate-800 dark:text-slate-100">
                                Contact
                              </p>
                            </div>
                            <div className="">
                              <ArrowOutwardIcon />
                            </div>
                          </div>
                        </a>
                      </div>
                    </>
                  );
                },
              },
            ]}
            data={leads}
            title={"Web Leads"}
            icons={icons}
            localization={{
              body: {
                emptyDataSourceMessage: "No Leads Were Found",
              },
            }}
          />
        </ThemeProvider>
      )}
    </div>
  );
};

export default WebLead;
